// components/CategoryFilter.tsx
import React, { useEffect, useState } from 'react';
import { BACKEND_URL } from '../config';
import axios from 'axios';

interface CategoryFilterProps {
  selected: string;
  onSelect: (tag: string) => void;
}

const CategoryFilter: React.FC<CategoryFilterProps> = ({ selected, onSelect }) => {
  const [tags, setTags] = useState<string[]>(['Featured']);

  useEffect(() => {
    const fetchTags = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/v1/categories`);
        const names = response.data.map((cat: { name: string }) => cat.name);
        setTags(['Featured', ...names]);
      } catch (err) {
        console.error("Failed to load tags:", err);
      }
    };

    fetchTags();
  }, []);

  return (
    <div className="filter-buttons-container">
      {tags.map((tag) => (
          <button
            key={tag}
            type="button"
            className={`filter-button filter-btn-small pill${selected === tag ? ' filter-button-active' : ''}`}
            style={{ textTransform: 'capitalize', letterSpacing: 0.2 }}
            onClick={() => onSelect(tag)}
          >
            {tag}
          </button>
      ))}
    </div>
  );
};

export default CategoryFilter;
